import { FilterItem } from "../filters";

export enum AdminManagementCompanySortField {
  NAME = "name",
  CREATED_AT = "createdAt",
  STATUS = "status",
}

export enum ManagementModel {
  SELF_MANAGED = 1,
  THIRD_PARTY = 2,
}

export enum ManagementCompanyUsageType {
  PRODUCTION = 1,
  DEMONSTRATION = 2,
}

export enum ManagementCompanyStatus {
  ACTIVE = 1,
  INACTIVE = 2,
  PROVISIONING = 3,
}

export const MANAGEMENT_COMPANY_STATUS_OPTIONS: FilterItem[] = [
  { value: String(ManagementCompanyStatus.ACTIVE), label: "Ativo" },
  { value: String(ManagementCompanyStatus.INACTIVE), label: "Inativo" },
  { value: String(ManagementCompanyStatus.PROVISIONING), label: "Carregando..." },
];

export const MANAGEMENT_MODEL_OPTIONS: FilterItem[] = [
  { value: String(ManagementModel.SELF_MANAGED), label: "Gestão Própria" },
  { value: String(ManagementModel.THIRD_PARTY), label: "Gestão de Terceiros" },
];

export const MANAGEMENT_USAGE_TYPE_OPTIONS: FilterItem[] = [
  { value: String(ManagementCompanyUsageType.PRODUCTION), label: "Produção" },
  { value: String(ManagementCompanyUsageType.DEMONSTRATION), label: "Demonstração" },
];
